import { useTheme } from '@/components/theme/theme-provider'

import { cn } from '@/utils/cn'

const UIThemeCard = () => {
    const { theme, setTheme } = useTheme()

    const className = 'mb-1 border-4 border-transparent cursor-pointer rounded-xl hover:border-primary'

    return (
        <div className="grid grid-cols-3 gap-4">
            <div>
                <img
                    className={cn(className, {
                        'border-primary': theme === 'system',
                    })}
                    src="/themes/system-theme.png"
                    alt="system theme"
                    onClick={() => setTheme('system')}
                />
                <p className="ml-1">System</p>
            </div>
            <div>
                <img
                    className={cn(className, {
                        'border-primary': theme === 'dark',
                    })}
                    src="/themes/dark-theme.png"
                    alt="system theme"
                    onClick={() => setTheme('dark')}
                />
                <p className="ml-1">Dark</p>
            </div>
            <div>
                <img
                    className={cn(className, {
                        'border-primary': theme === 'light',
                    })}
                    src="/themes/light-theme.png"
                    alt="system theme"
                    onClick={() => setTheme('light')}
                />
                <p className="ml-1">Light</p>
            </div>
        </div>
    )
}

export default UIThemeCard
